import React from 'react';
import { Moon, Sun } from 'lucide-react';
import * as S from './themeToggle.styles';

export const ThemeToggle = ({ isDark, toggleTheme }) => {
  return (
    <S.ToggleButton onClick={toggleTheme} aria-label="Toggle theme">
      <S.IconWrapper className="sun" $isDark={isDark}>
        <Sun />
      </S.IconWrapper>
      <S.IconWrapper className="moon" $isDark={isDark}>
        <Moon />
      </S.IconWrapper>
    </S.ToggleButton>
  );
};
